import React from "react";
import styles from "../../styles/FaqPageStyle.module.css";
import {
  Card,
  CardBody,
  Collapse,
} from "reactstrap";
import { useState } from "react";
import { AiOutlinePlusCircle, AiOutlineMinusCircle } from "react-icons/ai";
import Question from "../../assets/imgs/EF Branding Website/334731_quora_icon.png";
import Answer from "../../assets/imgs/EF Branding Website/letter-a (1).png";

const QuesThree = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => {
      setIsOpen(!isOpen);
    };
  return (
    <div>
      <div className="d-flex justify-content-center align-items-center">
        <img src={Question} alt="" style={{ width: "30px", height: "30px" }} />
        <button id="toggler3" className={styles.btn} onClick={toggle}>
          <span style={{ textAlign: "left" }}>What is the difference between Full container load (FCL) and Less than
          Container Load (LCL) services?</span>
          
          {!isOpen ? (
            <div className={styles.icon_container}>
              <AiOutlinePlusCircle className={styles.icon} />
            </div>
          ) : (
            <div className={styles.icon_container}>
              <AiOutlineMinusCircle className={styles.icon} />
            </div>
          )}
        </button>
      </div>
      <Collapse isOpen={isOpen}>
        <div className="d-flex mt-3">
          <img src={Answer} alt="" className={styles.img} />
          <Card style={{ width: "100%" }}>
            <CardBody>
              <ul>
                <li>
                  ● A full container load (FCL) is a container that is for the
                  use of a single consignee (for only one shipment).
                </li>
                <li>
                  ● A less container load (LCL) is a container that is for the
                  use of multiple consignees. (for many shipments together).
                </li>
              </ul>
            </CardBody>
          </Card>
        </div>
      </Collapse>
    </div>
  );
};
export default QuesThree;
